module.exports = __webpack_public_path__ + "img/full2-min.a74ff202.png";